module.exports = __webpack_public_path__ + "static/img/1.083d8cdd.png";